export default __webpack_public_path__ + "static/media/loading-screen-clouds-mobile.3249667e.svg";